import { gql, useMutation, useQuery } from '@apollo/client'
import CancelIcon from '@mui/icons-material/Cancel'
import EditIcon from '@mui/icons-material/Edit'
import {
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import Modal from 'components/Modal'
import React, { useState } from 'react'
import { Company, Dataroom } from 'utils/__generated__/graphql'

import { DataroomDataType, DataroomForm } from '../Create'
import { DATAROOM_BASE_QUERIES, DATAROOM_FRAGMENT } from '../constants'

const UPDATE_DATAROOM = gql`
  ${DATAROOM_FRAGMENT}
  mutation UPDATE_DATAROOM($id: ID!, $dataroom: DataroomInput!) {
    updateDataroom(id: $id, dataroom: $dataroom) {
      ...DataroomFragment
    }
  }
`

function Edit({ dataroom }: { dataroom: Dataroom }) {
  const [open, setOpen] = useState<boolean>(false)

  const theme = useTheme()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const [updateDataroom] = useMutation(UPDATE_DATAROOM)

  const handleDataroom = (data: DataroomDataType) => {
    updateDataroom({
      variables: { id: dataroom.id, dataroom: data },
      onCompleted: handleClose,
    })
  }

  const { loading, data } = useQuery(DATAROOM_BASE_QUERIES, {
    variables: { siteFilter: { isPublished: true }, companyFilter: {} },
    skip: !open,
  })

  const sites = data?.sites || []
  const companies = data?.companies || []

  const formValues = {
    site: dataroom.site?.id || '',
    name: dataroom.name || '',
    targetCompanies: (dataroom.targetCompanies || []).map(
      (company: Company | null) => company?.id || ''
    ),
  }

  return (
    <React.Fragment>
      <Modal open={open} width="75%" maxWidth={720}>
        <Stack
          direction="row"
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography
            sx={{ ...theme.typography.h5, color: theme.palette.text.primary }}
          >
            Edit - {dataroom.name}
          </Typography>
          <CancelIcon
            onClick={handleClose}
            sx={{ cursor: 'pointer', color: theme.palette.error.main }}
          />
        </Stack>
        <Divider sx={{ mt: 1, mb: 1 }} />
        {loading ? (
          <Stack sx={{ alignItems: 'center', p: 4 }}>
            <CircularProgress size={20} />
          </Stack>
        ) : (
          <DataroomForm
            values={formValues}
            onDataroom={handleDataroom}
            sites={sites}
            companies={companies}
          />
        )}
      </Modal>
      <IconButton onClick={handleOpen}>
        <Tooltip title="Edit" placement="top">
          <EditIcon />
        </Tooltip>
      </IconButton>
    </React.Fragment>
  )
}

export default Edit
